module.exports = __webpack_public_path__ + "static/img/7.0834c087.jpg";